/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import inputer report
import InputerMerchantTransaction from '../views/report/InputerMerchantTransaction.vue';
import InputerAggregatorTransaction from '../views/report/InputerAggregatorTransaction.vue';
import InputerCptsTransaction from '../views/report/InputerCptsTransaction.vue';

import { setBreadcrumb } from './index';

const inputerReportRoute = {
  path: '/inputer-report',
  name: 'InputerReport',
  children: [
    {
      path: '/report/inputer-cpts-transaction',
      meta: {
        title: 'BNI QRIS - Inputer CPTS Transaction',
        appBarTitle: 'Inputer CPTS Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'inputer cpts transaction',
            '/report/inputer-cpts-transaction'
          ),
        ],
      },
      component: InputerCptsTransaction,
      name: 'InputerCptsTransaction',
    },
    {
      path: '/report/inputer-merchant-transaction',
      meta: {
        title: 'BNI QRIS - Merchant Transaction',
        appBarTitle: 'Merchant Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'inputer merchant transaction',
            '/report/inputer-merchant-transaction'
          ),
        ],
      },
      component: InputerMerchantTransaction,
      name: 'InputerMerchantTransaction',
    },
    {
      path: '/report/inputer-merchant-transaction-ch',
      meta: {
        title: 'BNI QRIS - Merchant Transaction',
        appBarTitle: 'Merchant Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'inputer merchant transaction',
            '/report/inputer-merchant-transaction-ch'
          ),
        ],
      },
      component: InputerMerchantTransaction,
      name: 'InputerMerchantTransactionCh',
    },
    {
      path: '/report/inputer-aggregator-transaction',
      meta: {
        title: 'BNI QRIS - Aggregator Transaction',
        appBarTitle: 'Aggregator Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'inputer aggregator transaction',
            '/report/inputer-aggregator-transaction'
          ),
        ],
      },
      component: InputerAggregatorTransaction,
      name: 'InputerAggregatorTransaction',
    },
    {
      path: '/report/inputer-aggregator-transaction-ch',
      meta: {
        title: 'BNI QRIS - Aggregator Transaction',
        appBarTitle: 'Aggregator Transaction',
        breadcrumbs: () => [
          setBreadcrumb('report', '/report', true),
          setBreadcrumb(
            'inputer aggregator transaction',
            '/report/inputer-aggregator-transaction-ch'
          ),
        ],
      },
      component: InputerAggregatorTransaction,
      name: 'InputerAggregatorTransactionCh',
    },
  ],
  meta: {
    title: 'BNI QRIS - Report',
    appBarTitle: 'Report',
  },
  component: Parent,
};

export default inputerReportRoute;
